var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconPlayCircle = function SvgIconPlayCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M9.972 16.283V8.885a.5.5 0 0 1 .824-.381l4.351 3.698a.5.5 0 0 1 0 .762l-4.35 3.7a.5.5 0 0 1-.825-.381"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "m10.796 8.504-.324.38v7.399l4.351-3.7-4.35-3.698zm-1.324.38a1 1 0 0 1 1.648-.761l4.35 3.698a1 1 0 0 1 .001 1.524l-4.351 3.7a1 1 0 0 1-1.648-.762z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M12.055 21.584a8.978 8.978 0 1 0 0-17.957 8.978 8.978 0 0 0 0 17.957m0 1c5.511 0 9.979-4.468 9.979-9.978 0-5.512-4.468-9.979-9.979-9.979s-9.978 4.467-9.978 9.979c0 5.51 4.467 9.978 9.978 9.978",
    clipRule: "evenodd"
  })));
};
export default SvgIconPlayCircle;